import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

RHFDateTimeField.propTypes = {
  name: PropTypes.string.isRequired,
  disablePast: PropTypes.bool,
  mode: PropTypes.oneOf(['dateTime', 'time']),
  startTime: PropTypes.any,
  isEndTime: PropTypes.bool,
};

RHFDateTimeField.defaultProps = {
  disablePast: false,
  mode: 'dateTime',
  startTime: null,
  isEndTime: false,
};

export default function RHFDateTimeField({ name, disablePast, maxDateTime, mode, startTime, isEndTime, mTime, disabled, ...other }) {
  const { control } = useFormContext();
  const minDateTime = disablePast ? new Date() : undefined; // Prevent selection of past dates/times

  const minTime = isEndTime && startTime ? dayjs(startTime) : null;
  const maxTime = mTime ? dayjs().hour(14).minute(0) : null; // 14:00 = 2:00 PM

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={mode === 'time' ? AdapterDayjs : AdapterDateFns}>
          {mode === 'time' ? (
            <TimePicker
              {...field}
              ampm={false}
              views={['hours', 'minutes']}
              inputFormat="HH:mm"
              disabled={disabled}
              minutesStep={5}
              value={field.value || null}
              minTime={minTime}
              maxTime={maxTime}
              onChange={(newValue) => field.onChange(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={!!error}
                  helperText={error?.message}
                  fullWidth
                  variant="outlined"
                  {...other}
                />
              )}
            />
          ) : (
            <DateTimePicker
              {...field}
              ampm={false}
              inputFormat="dd/MM/yyyy HH:mm"
              value={field.value || null}
              minDateTime={minDateTime}
              maxDateTime={maxDateTime}
              renderInput={(params) => (
                <TextField
                  {...params}
                  error={!!error}
                  helperText={error?.message}
                  fullWidth
                  variant="outlined"
                  {...other}
                />
              )}
            />
          )}
        </LocalizationProvider>
      )}
    />
  );
}
